import { DialogService } from 'primeng/dynamicdialog';
import { ActionTypeEnum, ActionTypeHandlerEnum } from '../enums';
import { IActionConfig, IDefaultCustomExecutor, IDefaultDialogResolverConfig, IDefaultRedirectConfig } from '../types';
import { Router } from '@angular/router';

export class ActionConfigFactory {
  static createDialog<TEntity>(
    service: DialogService,
    defaultConfig: IDefaultDialogResolverConfig<TEntity>
  ): IActionConfig<TEntity> {
    return {
      ...defaultConfig,
      handlerType: ActionTypeHandlerEnum.DIALOG,
      handlerConfig: {
        componentType: defaultConfig.componentType,
        configResolver: (item?: TEntity) => ({
          data: {
            item: item,
            visible: defaultConfig.type !== ActionTypeEnum.VIEW
          },
          header: defaultConfig.headerResolver(item),
          width: defaultConfig.width || '50%'
        }),
        service: service
      }
    };
  }

  static createRedirect<TEntity>(
    router: Router,
    defaultConfig: IDefaultRedirectConfig<TEntity>
  ): IActionConfig<TEntity> {
    return {
      ...defaultConfig,
      type: defaultConfig.type || ActionTypeEnum.VIEW,
      handlerType: ActionTypeHandlerEnum.REDIRECT,
      handlerConfig: {
        urlResolver: defaultConfig.urlResolver,
        router
      }
    };
  }

  static createCustomExecutor<TEntity>(defaultConfig: IDefaultCustomExecutor<TEntity>): IActionConfig<TEntity> {
    return {
      ...defaultConfig,
      handlerType: ActionTypeHandlerEnum.CUSTOM_EXECUTOR,
      handlerConfig: {
        execute: defaultConfig.execute
      }
    };
  }
}
